import React from 'react';
import Window from '../os/Window';
import Wordle from '../wordle/Wordle';

export interface wordyAppProps extends WindowAppProps {}

const wordyApp: React.FC<wordyAppProps> = (props) => {
    return (
        <Window
            top={20}
            left={300}
            width={600}
            height={860}
            windowBarIcon="windowGameIcon"
            windowTitle="wordy"
            closeWindow={props.onClose}
            onInteract={props.onInteract}
            minimizeWindow={props.onMinimize}
            bottomLeftText={'© Copyright 2024 Eray Çakın'}
        >
            <div className="site-page">
                <Wordle />
            </div>
        </Window>
    );
};

export default wordyApp;
